import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIcon({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={125}
      height={125}
      viewBox="0 0 125 125"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF" cx={62.5} cy={62.5} r={62.5} />
        <path
          d="M108.07 37.587c-.226-.445-.485-.932-.84-1.599-2-3.59-4.61-6.965-7.533-9.93L65.538 60.178l-7.692-7.96L48 62.053 65.385 80l42.685-42.413z"
          fill="#EF8165"
          fillRule="nonzero"
        />
        <path
          d="M99.423 55.81c.312 1.866.468 3.889.468 5.911 0 15.248-8.89 29.25-22.772 35.629-13.413 5.757-28.854 3.423-39.928-5.912C23.466 78.99 20.034 58.92 28.925 42.585c8.578-15.247 26.515-22.715 43.36-18.048 4.522 1.245 8.734 3.423 12.477 6.379l9.514-9.49c-3.743-2.957-7.799-5.602-12.322-7.469C61.21 5.09 36.567 11.624 22.218 28.582c-13.413 16.18-16.065 38.74-6.55 57.41 10.761 20.226 33.22 31.117 55.836 27.227 28.075-5.134 46.791-32.05 41.644-60.055-.468-2.956-1.248-5.756-2.34-8.557L99.424 55.81z"
          fill="#373A3C"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}
export default SvgIcon;
